var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79545 10.3637V3.43752C8.79545 2.35492 9.67308 1.47729 10.7557 1.47729H23.0398C24.1224 1.47729 25 2.35492 25 3.43752V23.0398C25 24.1224 24.1224 25 23.0398 25H14.5455M8.79545 10.3637L3.04545 16.1137M8.79545 10.3637L14.5455 16.1137M2 17.1591L3.04545 16.1137M3.04545 16.1137V23.0398C3.04545 24.1224 3.92308 25 5.00568 25H14.5455M15.5909 17.1591L14.5455 16.1137M14.5455 16.1137V25",
    stroke: "#464555",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.22665,
    y: 17.1592,
    width: 2.61364,
    height: 2.61364,
    fill: "#464555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7259,
    y: 15.0701,
    width: 2.61364,
    height: 2.61364,
    fill: "#464555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7259,
    y: 9.8418,
    width: 2.61364,
    height: 2.61364,
    fill: "#464555"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7259,
    y: 4.61377,
    width: 2.61364,
    height: 2.61364,
    fill: "#464555"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4992,
    y: 4.61377,
    width: 2.61364,
    height: 2.61364,
    fill: "#464555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.cbb35ae9e32260b0978e5763a0a1e191.svg";
export { ForwardRef as ReactComponent };